import { Component } from '@angular/core';
import { AuthorizeService } from '../../services/authorize.service';

@Component({
  selector: 'app-logout',
  template: ``,
  standalone: false,
})
export class LogoutComponent {
  constructor(private _authorizeService: AuthorizeService) {
    this._authorizeService.logout();
  }
}
